<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-alert v-model="showError" variant="danger" dismissible>
           <p>{{ error }} / {{ error_data.message }}</p>
           <ul v-for="e in error_data.errors" :key="e">
             <li>{{ e }}</li>
           </ul>

          </b-alert>

          <b-alert v-model="showSuccess" variant="success" dismissible>
           <p>SMS message with ID {{ data.uuid }} created!</p>
          </b-alert>

      <div class="text-left">
        <b-row>
          <b-col cols="2">
            Sender:
          </b-col>
          <b-col cols="10">
            <b-form-group
              description="Max 11 characters are allowed"
            >
              <b-form-input
                v-model="sender"
                placeholder="Enter sender identifier"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            Retention:
          </b-col>
          <b-col cols="10">
            <b-form-group
              description="How long the message (logs) get stored"
            >
              <b-form-input
                v-model="retention"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            Destination:
          </b-col>
          <b-col cols="10">
            <b-form-group
              description="Destination phone number (format: +41761234567)"
            >
              <b-form-input
                v-model="destination"
                placeholder="Enter destination phone number"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            Text:
          </b-col>
          <b-col cols="10">
            <b-form-group
              description="SMS text"
            >

            <b-form-textarea
              v-model="text"
              placeholder="Enter SMS text"
              rows="3"
              max-rows="6"
              required
            ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

      </div>

          <b-button @click="onSubmit()" type="submit" variant="primary" :disabled="disabledButton">Submit</b-button>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      sender: 'Ophion',
      retention: 7,
      destination: null,
      text: null,
      showError: false,
      showSuccess: false,
      error_data: {
        message: null,
        errors: []
      },
      data: {
        created: null,
        destination: null,
        log: [],
        retention: null,
        sender: null,
        state: null,
        text: null,
        uuid: null
      },
      error: null
    }
  },
  computed: {
    disabledButton: function () {
      let disabled = false

      if (this.sender === null) {
        disabled = true
      }

      if (this.retention === null) {
        disabled = true
      }

      if (this.destination === null) {
        disabled = true
      }

      if (this.text === null) {
        disabled = true
      }

      return disabled
    }
  },
  methods: {
    onSubmit () {
      let url = process.env.BASE_URL + '/api/send'
      let config = {
        headers: {
          Token: sessionStorage.getItem('token')
        }
      }

      let data = {
        sender: this.sender,
        retention: parseInt(this.retention),
        destination: this.destination,
        text: this.text
      }

      axios.post(url, data, config).then(response => {
        this.data = response.data
        this.showSuccess = true
      }).catch(err => {
        this.error = err
        this.error_data = err.response.data
        this.showError = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Send.vue